import React, { useState, useEffect } from 'react'

import Grid from '@mui/material/Grid';

import WorkerFilterCriteria from './WorkerFilterCriteria'
import WorkerList from './WorkerList'
import MyPageContainer from '../../core/template/MyPageContainer';
import {getListAPI} from './WorkerAPI';
import {transformToCardFormat} from '../../core/js/FormUtils'
import {getPathVariable} from '../../core/js/UrlUtils';

import { useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import {setWorkerDashboardWorkerList } from '../../store/slice/ManufSlice';

export default function WorkerListView({setShowEdit,setWorkerId}){
    const {filterCriteria} = useSelector((state)=>state.manufslice.workerDashboard);   

    const [filteredWorkerList, setFilteredWorkerList] = React.useState([]);
    const [cardList, setCardList] = useState([]);
    const [searchParams, setSearchParams] = useSearchParams();
    const { showfilter } = useSelector((state) => state.confslice);
    const { workerDashboard } = useSelector((state) => state.manufslice);
    
    function dataFetchCallBack(){
    }

    useEffect(()=>{
      if (workerDashboard.workerList.length>-1){
        setFilteredWorkerList(workerDashboard.workerList);
        transformToCardFormat(workerDashboard.workerList, setCardList);
      }
    },[workerDashboard.workerList])

    useEffect(()=>{
          transformToCardFormat(filteredWorkerList, setCardList);
      },[filteredWorkerList])

    useEffect(()=>{
        if (filterCriteria.title==='' && filterCriteria.skillid==='' && filterCriteria.skillname==='' && filterCriteria.experiencelevelid==='' && filterCriteria.typeid==='' ){
            setFilteredWorkerList(workerDashboard.workerList);
            transformToCardFormat(workerDashboard.workerList, setCardList);

        } else {
            setFilteredWorkerList(
                workerDashboard.workerList
                    .filter(worker=> worker.title.toString().toUpperCase().includes(filterCriteria.title.toString().toUpperCase()))
.filter(worker=> worker.skillname.toString().toUpperCase().includes(filterCriteria.skillname.toString().toUpperCase()))

                
            )
            

            //transformToCardFormat(workerDashboard.filteredWorkerList, setCardList);
        }
      },[filterCriteria])
  
     return(
        <Grid container direction="column" >
            <Grid item lg={12}>
                <WorkerList
                    setShowEdit={setShowEdit}
                    setWorkerId = {setWorkerId}
                    tableList={filteredWorkerList}
                    cardList={cardList}
                    />
          </Grid>
      </Grid>
    )
}